module.exports = __webpack_public_path__ + "media/images/wedding/top/hall-list/plan-wedding-lineup-kansai-2-2c0ed5cd748c15f6840bf285a140f93d.png";